import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';
import { getPerformance } from 'firebase/performance';
import { getFunctions, httpsCallable } from 'firebase/functions';

export const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
  measurementId: process.env.NEXT_PUBLIC_FIREBASE_MESUREMENT_ID,
};

export const firebaseApp = initializeApp(firebaseConfig);
export const firebaseAuthClient = getAuth(firebaseApp);
export const firebaseFunctions = getFunctions(firebaseApp, 'europe-west1');
export const firebaseCallable = httpsCallable;

if (typeof window !== 'undefined') {
  const host = window.location?.hostname;
  if (
    host === 'localhost' ||
    host === '127.0.0.1' ||
    host === 'https://gomo-world-website-827133312079.europe-west1.run.app/'
  ) {
    window.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
  }

  initializeAppCheck(firebaseApp, {
    provider: new ReCaptchaV3Provider(process.env.NEXT_PUBLIC_APP_CHECK || ''),
    isTokenAutoRefreshEnabled: true,
  });
  getPerformance(firebaseApp);
}
